import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Outlet } from "react-router";
import { useTranslation } from "react-i18next";
function MainLayout() {
  const { i18n } = useTranslation();
  return (
    <div className={i18n.language === "ar" ? "font-ar" : "font-en"}>
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}

export default MainLayout;
